import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ 
  buildings, 
  selectedBuildings, 
  onBuildingsChange,
  roomTypes,
  selectedRoomTypes,
  onRoomTypesChange,
  dateRange,
  onDateRangeChange,
  onReset
}) => {
  const buildingOptions = buildings?.map(b => ({ value: b, label: b }));
  const roomTypeOptions = roomTypes?.map(t => ({ value: t, label: t }));
  
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Filters</h3>
        <button
          onClick={onReset}
          className="flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground transition-smooth"
        >
          <Icon name="RotateCcw" size={14} />
          Reset
        </button>
      </div>

      <div className="space-y-4">
        <Select
          label="Buildings"
          placeholder="Select buildings"
          options={buildingOptions}
          value={selectedBuildings}
          onChange={onBuildingsChange}
          multiple
          searchable
          clearable
        />

        <Select
          label="Room Types"
          placeholder="Select room types"
          options={roomTypeOptions}
          value={selectedRoomTypes}
          onChange={onRoomTypesChange}
          multiple
          searchable
          clearable
        />

        <Select
          label="Date Range"
          placeholder="Select date range"
          options={dateRangeOptions}
          value={dateRange}
          onChange={onDateRangeChange}
        />

        <div className="pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Info" size={14} />
            <span>Filters apply to all visualizations</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;